// extracted by mini-css-extract-plugin
export default {"component":"noteDialog__component___3DoVM","formComponent":"noteDialog__formComponent___MKSr6","textField":"noteDialog__textField___2exKj"};